<template>
    <div class="file-uploader">
        <div class="dropbox">
            <input
                type="file"
                ref="file"
                :disabled="isSaving"
                @change="handleFileUpload()"
                accept="image/*"
                class="input-file"
            >
            <p v-if="isInitial">
                {{ $t("utilities.fileUploader.dragOrClick") }}
            </p>
            <p v-if="isSaving">
                {{ $t("utilities.fileUploader.uploading") }}
            </p>
        </div>
        <div class="preview">
            <template v-if="base64.length > 0">
                <img :src="base64" class="preview-img img-fluid">
            </template>
            <template v-else-if="filename.length > 0">
                <img :src="`${previewSrc}`" class="preview-img img-fluid">
            </template>
            <template v-else>
                <font-awesome-icon icon="file-image" />
            </template>
        </div>
        <p class="help-text">
            {{ $t("utilities.fileUploader.uploadHelp", { size: '500' }) }}
            <template v-if="resolution.length > 0">
                {{ $t("utilities.fileUploader.resolutionHelp", { res: resolution }) }}
            </template>
        </p>
    </div>
</template>

<script>
import axios from 'axios'
const STATUS_INITIAL = 0
const STATUS_SAVING = 1

export default {
  name: 'ThemeEditor',
  data () {
    return {
      file: '',
      base64: '',
      currentStatus: STATUS_INITIAL
    }
  },
  props: {
    backendId: String,
    for: String,
    filename: String,
    resolution: String
  },
  computed: {
    isInitial () {
      return this.currentStatus === STATUS_INITIAL
    },
    isSaving () {
      return this.currentStatus === STATUS_SAVING
    },
    previewSrc () {
      let path = this.$store.getters.urlPath + 'static/uploads/'
      return path + this.filename
    }
  },
  methods: {
    handleFileUpload () {
      this.file = this.$refs.file.files[0]
      this.readFile()
    },
    readFile () {
      let me = this
      if (this.file && this.file instanceof File) {
        this.currentStatus = STATUS_SAVING
        // Use filereader to get base64 for thumbnail
        var reader = new FileReader()
        reader.onload = function (e) {
          // Get the actual file
          let formData = new FormData()
          formData.append('for', me.for)
          formData.append('file', me.file)
          formData.append('id', me.backendId)
          axios.post(me.$store.getters.urlPath + 'services/manager/saveFile.php', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
            .then((response) => {
              // Notify parent component
              me.$emit('input', response.data.file)
              // Set base64 image
              me.base64 = e.target.result
            })
            .catch((error) => {
              // eslint-disable-next-line
              console.log(error)
            })
            .then(function () {
              me.reset()
            })
        }
        reader.readAsDataURL(this.file)
      }
    },
    reset () {
      this.file = ''
      this.currentStatus = STATUS_INITIAL
    }
  }
}
</script>

<style lang="scss" scoped>
$borderColor: #dee2e6;

.file-uploader {
    display: flex;
    flex-wrap: wrap;

    .dropbox {
        outline: 2px dashed grey;
        outline-offset: -10px;
        color: dimgray;
        padding: 10px 10px;
        min-height: 100px;
        position: relative;
        cursor: pointer;
        width: 70%;
        border: 2px solid $borderColor;
        border-bottom-left-radius: 5px;
        border-top-left-radius: 5px;

        .input-file {
            opacity: 0;
            width: 100%;
            height: 100%;
            position: absolute;
            cursor: pointer;
        }

        p {
            font-size: 1.2em;
            text-align: center;
            padding: 20px 0 0 0;
        }
    }
    .preview {
        width: 30%;
        padding: 5px;
        border: 2px solid $borderColor;
        border-left: none;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        text-align: center;

        .preview-img {
            max-height: 100px;
        }
        .fa-file-image {
            font-size: 85px;
            padding: 5px;
            opacity: 0.1;
        }
    }
    .help-text {
        width: 100%;
        text-align: right;
        opacity: 0.5;
        font-size: 0.7em;
    }
}
</style>
